export default __webpack_public_path__ + "static/media/cabinet003.1fdde7f9.jpeg";